<template>
    <template v-if="!isIssuesListEmpty">
        <div v-for="(issue, index) in issues" :key="issue.id" class="mb-0 mt-0">
            <inquiries-card :issue="issue" :loading="loading" :is-last="isLastItem(index)" />
        </div>
    </template>
    <template v-else>
        <empty-state>
            {{ emptyStateContent.before }}
            <a class="text-primary" target="_blank" :href="config.frequentlyAskedQuestionsUrl">{{ t('inquiry.emptyStateButton') }}</a>
            {{ emptyStateContent.after }}
        </empty-state>
    </template>
</template>

<script setup lang="ts">
import InquiriesCard from '../card/IssuesCard.vue';
import { useI18n } from 'vue-i18n';
import { IIssuesCardList } from '../../types';
import { isLastItemReached, splitTextPattern } from '@/helpers';
import EmptyState from '@/features/common/components/EmptyState.vue';
import { computed } from 'vue';
import { useAppConfiguration } from '@/composables';

const { t } = useI18n();
const { config } = useAppConfiguration();

const props = defineProps<IIssuesCardList>();

const emptyStateContent = computed(() => splitTextPattern(t('inquiry.emptyState'), '[FAQ]'));

const isLastItem = (index: number) => isLastItemReached(index, props.issues.length);
</script>
